import Translator, { __ } from "services/Translator";

//Auth module
import PrivateRoute from "routes/PrivateRoute";
import OpenRoute from "routes/OpenRoute";
import ChatRoute from "routes/ChatRoute";

// import external modules
import React, { Component, lazy, useEffect, useState } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";

// new pages
import WelcomePromotions from "../pages/WelcomePromotions";
import SlotsPromotions from "../pages/SlotsPromotions";
import PokerPromotiops from "../pages/PokerPromotiops";
import SportsbookPromotions from "../pages/SportsbookPromotions";
// import stakeLanding from "pages/stakeLanding";
import Landing from "pages/Landing";
import BingoLanding from "pages/BingoLanding";
import PokerLanding from "pages/PokerLanding";
import SportsLanding from "pages/SportsLanding";
import Error from "pages/Error";
import Promotions from "pages/Promotions";
import Games from "pages/Games";
import GamePlay from "pages/GamePlay";
import FAQ from "pages/FAQ";
import Vip from "pages/Vip";
import SignUp from "pages/Landing";
import UserDashboard from "pages/UserDashboard";
import Page from "pages/Page";
import Races from "pages/Races";
import LangFixer from "pages/LangFixer";
import Chat from "elements/Chat";
import Rewards from "pages/Rewards";

// auth pages
import Login from "pages/auth/Login";
import Register from "pages/auth/Register";
import RecoverPassword from "pages/auth/RecoverPassword";
import ResetPassword from "pages/auth/ResetPassword";
import ResendActivation from "pages/auth/ResendActivation";
// import AccountActivated from "pages/Landing";

import Blogs from "pages/Blogs";
import BlogDetails from "pages/BlogDetails";
import Bitcoin from "pages/Bitcoin";
import Affiliate from "pages/Affiliates";

//Stores
import Stores from "pages/Stores";

//Tickets
import Tickets from "pages/Tickets";
import TicketDetails from "pages/TicketDetails";
import InteracResult from "pages/InteracResult";
import ls from "services/ls";

// const Landing = lazy(() => import("pages/Landing"));
// import { BrowserRouter, Switch, Redirect } from "react-router-dom";

function OpenRoutes() {
  // const match = useRouteMatch("/:lang/:rest");
  // console.log(match);

  //Theme selection / Landing type
  const [landingType, setLandingType] = useState(ls.get("selectedTheme"));
  const randomStr = Math.random();
  useEffect(() => {
    setLandingType(ls.get("selectedTheme"));
    // alert(ls.get("selectedTheme"));
  }, [randomStr]);

  return (
    <BrowserRouter basename={"/" + Translator.getSelectedLanguage().code + "/"}>
      <Switch>
        <OpenRoute exact path={"/"} component={Landing}></OpenRoute>

        <OpenRoute
          exact
          path={"/welcome-promotions"}
          component={WelcomePromotions}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/slots-promotions"}
          component={SlotsPromotions}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/poker-promotions"}
          component={PokerPromotiops}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/sportsbook-promorions"}
          component={SportsbookPromotions}
        ></OpenRoute>

        <OpenRoute
          exact
          path={"/account-activated"}
          component={Landing}
        ></OpenRoute>
        <OpenRoute exact path={"/bingo"} component={BingoLanding}></OpenRoute>
        <OpenRoute exact path={"/poker"} component={PokerLanding}></OpenRoute>
        <OpenRoute
          exact
          path={"/sports-betting"}
          component={SportsLanding}
        ></OpenRoute>
        <OpenRoute exact path={"/error"} component={Error}></OpenRoute>
        <OpenRoute exact path={"/vip"} component={Vip}></OpenRoute>
        <OpenRoute exact path={"/rewards"} component={Rewards}></OpenRoute>
        <OpenRoute exact path={"/faqs"} component={FAQ}></OpenRoute>
        <OpenRoute
          exact
          path={"/promotions"}
          component={Promotions}
        ></OpenRoute>
        <OpenRoute exact path={"/bitcoin"} component={Bitcoin}></OpenRoute>
        <OpenRoute exact path={"/signup"} component={SignUp}></OpenRoute>
        <OpenRoute exact path={"/terms"} component={Page}></OpenRoute>
        <OpenRoute exact path={"/bonus-terms"} component={Page}></OpenRoute>
        <OpenRoute exact path={"/privacy"} component={Page}></OpenRoute>
        <OpenRoute exact path={"/aml-policy"} component={Page}></OpenRoute>
        <OpenRoute exact path={"/legal"} component={Page}></OpenRoute>
        <OpenRoute exact path={"/affiliates"} component={Affiliate}></OpenRoute>
        <OpenRoute exact path={"/vip-program"} component={Page}></OpenRoute>
        <OpenRoute
          exact
          path={"/games/:category"}
          component={Games}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/play/:slug/:mode?"}
          component={GamePlay}
        ></OpenRoute>
        {/* auth pages */}
        <OpenRoute
          exact
          path={"/reset-password/:userId/:code"}
          component={ResetPassword}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/resend-activation"}
          component={ResendActivation}
        ></OpenRoute>

        <OpenRoute exact path={"/login"} component={Login}></OpenRoute>
        <OpenRoute exact path={"/register"} component={Register}></OpenRoute>
        <OpenRoute
          exact
          path={"/recover-password"}
          component={RecoverPassword}
        ></OpenRoute>

        <OpenRoute exact path={"/races"} component={Races}></OpenRoute>
        <OpenRoute exact path={"/blogs"} component={Blogs}></OpenRoute>
        <OpenRoute
          exact
          path={"/blog-details/:slug"}
          component={BlogDetails}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/interac-result/:res"}
          component={InteracResult}
        />
        <OpenRoute path="*" component={LangFixer} />
      </Switch>
    </BrowserRouter>
  );
}

class PrivateRoutes extends Component {
  render() {
    return (
      <BrowserRouter
        basename={"/" + Translator.getSelectedLanguage().code + "/"}
      >
        <Switch>
          <PrivateRoute exact path="/" component={Landing}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/bitcoin"}
            component={Bitcoin}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/games/:category"}
            component={Games}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/play/:slug/:mode?"}
            component={GamePlay}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/dashboard/:tab?"}
            component={UserDashboard}
          ></PrivateRoute>

          <PrivateRoute
            exact
            path={"/promotions"}
            component={Promotions}
          ></PrivateRoute>

          <PrivateRoute exact path={"/vip"} component={Vip}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/rewards"}
            component={Rewards}
          ></PrivateRoute>
          <PrivateRoute exact path={"/faqs"} component={FAQ}></PrivateRoute>
          <PrivateRoute exact path={"/terms"} component={Page}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/bonus-terms"}
            component={Page}
          ></PrivateRoute>
          <PrivateRoute exact path={"/privacy"} component={Page}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/aml-policy"}
            component={Page}
          ></PrivateRoute>
          <PrivateRoute exact path={"/legal"} component={Page}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/vip-program"}
            component={Page}
          ></PrivateRoute>
          <ChatRoute exact path="/chat" component={Chat}></ChatRoute>
          <PrivateRoute exact path={"/races"} component={Races}></PrivateRoute>

          <PrivateRoute exact path={"/blogs"} component={Blogs}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/blog-details/:slug"}
            component={BlogDetails}
          ></PrivateRoute>

          <PrivateRoute exact path={"/store"} component={Stores}></PrivateRoute>

          <PrivateRoute exact path={"/tickets"} component={Tickets} />
          <PrivateRoute
            exact
            path={"/ticket-details/:id"}
            component={TicketDetails}
          />
          <PrivateRoute
            exact
            path={"/interac-result/:res"}
            component={InteracResult}
          />
          <PrivateRoute
            exact
            path={"/affiliates"}
            component={Affiliate}
          ></PrivateRoute>
          <PrivateRoute path="*" component={LangFixer} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export { OpenRoutes, PrivateRoutes };
